import React, { Component } from 'react'
import PubSub from 'pubsub-js'
import axios from 'axios'

export default class Search extends Component {

    search=()=>{
        //取得用戶的輸入
        const{keyWordNode:{value:keyWord}} = this
        //發送請求前通知List更新狀態
        PubSub.publish('SearchData',{isFirst:false,isLoading:true})
        //發送網路請求
        axios.get(`https://api.github.com/search/users?q=${keyWord}`).then(
            response => {
                //請求成功後通知List更新狀態
                PubSub.publish('SearchData',{isLoading:false,users:response.data.items})
            },
            error =>{
                //發生錯誤時通知List更新狀態
                PubSub.publish('SearchData',{isLoading:false,err:error.message})//不要直接存錯誤物件 要存物件上的message
            }
        )
    }

    render() {
        return (
        <section className="jumbotron">
            <h3 className="jumbotron-heading">Search Github Users</h3>
            <div>
                <input ref={c=>this.keyWordNode  = c} type="text" placeholder="輸入關鍵字" />&nbsp;
                <button onClick={this.search} >開始搜尋</button>
            </div>
        </section>
        )
    }
}
